/**
 * Late-join helpers (worldcup-late-join-extension).
 *
 * A player who joins after the tournament has started FORFEITS every match that kicked off before
 * they joined: the server seeds no pick for those matches, so they have no `prediction`. We surface
 * that to the user with a "Joined mid-tournament" marker and a one-time banner, derived purely from
 * the match feed — a finished match with no prediction means the viewer never had a pick for it.
 */

import type { WorldCupMatch } from '../types/worldcup.types';

/**
 * True when this finished match was missed because the viewer joined after it kicked off — i.e. the
 * match is finished and the viewer holds no prediction for it. On-time members always have a pick
 * (their own or a monkey default), so this is false for them.
 */
export function isMatchMissedPreJoin(match: Pick<WorldCupMatch, 'status' | 'prediction'>): boolean {
  return match.status === 'finished' && match.prediction == null;
}

/**
 * True when the viewer joined mid-tournament — they have at least one finished match with no pick.
 */
export function isLateJoiner(matches: Pick<WorldCupMatch, 'status' | 'prediction'>[]): boolean {
  return matches.some(isMatchMissedPreJoin);
}
